import script from "./Fuwu.vue?vue&type=script&setup=true&lang=js"
export * from "./Fuwu.vue?vue&type=script&setup=true&lang=js"

import "./Fuwu.vue?vue&type=style&index=0&id=5a344446&lang=less&scoped=true"
script.__scopeId = "data-v-5a344446"

export default script